$(".header-top").append($(".top-navigation-bar .responsive-tools").clone());
$(".header-top .responsive-tools").prepend(
    $(".top-navigation-tools .dropdown").clone(),
);
$('.navigation-buttons a[data-target="cart"]')
    .clone()
    .appendTo(".header-top .responsive-tools");


